module.exports = __webpack_public_path__ + "img/Screen_Shot_7.a006ec75.png";